import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { editorUpdateLabel, editorUpdatePlaceholder } from '../../../../../../../store/pages-management/actions'
import { FieldProps as Props } from './types'

const TextField: FC<Props> = ({ strings, field }) => {
  // REDUX STORE
  const dispatch = useDispatch()

  return (
    <div className="columns field_content">
      <div className="column is-6">
        <label>{ strings.label }</label>
        <input
          type="text"
          className="grey full-width"
          value={ field.label }
          onChange={ (e) => dispatch(editorUpdateLabel(field.id, e.target.value)) }
        />
      </div>

      <div className="column is-6">
        <label>{ strings.example }</label>
        <input
          type="text"
          className="grey full-width"
          value={ field.placeholder }
          onChange={ (e) => dispatch(editorUpdatePlaceholder(field.id, e.target.value)) }
        />
      </div>
    </div>
  )
}

export default TextField